import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { useAddReaction, useRemoveReaction, } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { useLogin } from '../../common/hooks/useLogin';
import { useI18n } from '../../i18n';
import { confirmActionOnLockedPost } from '../utils';
export const SingleReaction = ({ post, text, reaction, Icon, className, simple = false, showCount = false, }) => {
    const intl = useI18n();
    const { mutate: removeReaction } = useRemoveReaction();
    const { mutate: addReaction } = useAddReaction();
    const { isLoggedIn, showLogin } = useLogin();
    const selectedReaction = useMemo(() => { var _a; return (_a = post === null || post === void 0 ? void 0 : post.reactions) === null || _a === void 0 ? void 0 : _a.find(r => r.reaction === reaction); }, [post.reactions, reaction]);
    const reacted = selectedReaction === null || selectedReaction === void 0 ? void 0 : selectedReaction.reacted;
    let disabled;
    if (post && isLoggedIn) {
        const [canReact] = hasScopesPermission(post, ['addReaction']);
        if (!canReact || !post.authMemberProps.canReact) {
            disabled = true;
        }
    }
    const onRemoveReaction = useCallback(async (reaction) => {
        if (!(await confirmActionOnLockedPost(intl)(post))) {
            return;
        }
        removeReaction({
            postId: post.id,
            reaction,
        });
    }, [removeReaction, post, intl]);
    const onAddReaction = useCallback(async (reaction) => {
        if (!isLoggedIn) {
            return showLogin();
        }
        if (!(await confirmActionOnLockedPost(intl)(post))) {
            return;
        }
        addReaction({
            postId: post === null || post === void 0 ? void 0 : post.id,
            input: {
                reaction,
            },
        });
    }, [addReaction, post, showLogin, isLoggedIn, intl]);
    if (simple) {
        return (_jsxs(Link, { variant: reacted ? 'accent' : 'neutral', disabled: disabled, className: clsx('flex items-center', className), onClick: () => {
                if (reacted) {
                    onRemoveReaction(reaction);
                }
                else {
                    onAddReaction(reaction);
                }
            }, children: [_jsx("span", { className: "me-2", children: Icon }, void 0), _jsx("span", { children: text }, void 0)] }, void 0));
    }
    return (_jsx("div", { className: "flex-1 flex min-w-0", children: _jsx(Button, { variant: "outline", className: clsx('group', reacted && ' bg-surface-subdued hover:bg-surface-hovered', className), size: "md", fullWidth: true, disabled: disabled, leadingIcon: !showCount && Icon, onClick: e => {
                e.preventDefault();
                if (reacted) {
                    onRemoveReaction(reaction);
                }
                else {
                    onAddReaction(reaction);
                }
            }, children: showCount ? (_jsxs("span", { className: "flex flex-col", children: [Icon, _jsx("span", { className: "-mt-1", children: post === null || post === void 0 ? void 0 : post.reactionsCount }, void 0)] }, void 0)) : (_jsx("div", { className: "truncate", children: text }, void 0)) }, void 0) }, void 0));
};
//# sourceMappingURL=SingleReaction.js.map